<template>
  <div class="upload-div">
    <div class="upload-title">
      请上传身份证头像图
    </div>
    <van-uploader :after-read="afterRead">
      <img src="@/assets/images_member/20230804/image 11@2x.png" v-if="!face_img" class="upload-img" alt="">
      <img :src="face_img" v-else class="upload-img" alt="">
    </van-uploader>
    <div class="upload-title">
      请上传身份证国徽图
    </div>
    <van-uploader :after-read="afterRead2">
      <img src="@/assets/images_member/20230804/image 12@2x.png" v-if="!back_img" class="upload-img" alt="">
      <img :src="back_img" v-else class="upload-img" alt="">
    </van-uploader>
    <div class="submit-btn">
      <div class="btn-txt" @click="handleSubmit">确定上传</div>
    </div>
    <van-overlay :show="isSubmit">
      <van-loading type="spinner"/>
    </van-overlay>
  </div>
</template>
<script>
import { uploadPic, getIdCardInfo } from '@/api/person'
export default {
  data () {
    return {
      face_img: '',
      back_img: '',
      isSubmit: false
    }
  },
  methods: {
    afterRead (e) {
      this.isSubmit = true
      const formData = new FormData()
      formData.append('file', e.file)
      uploadPic(formData).then(res => {
        this.face_id = res.data.id
        this.face_img = process.env.viewURL + res.data.path
        this.isSubmit = false
      }).catch(() => {
        this.isSubmit = false
      })
    },
    afterRead2(e) {
      this.isSubmit = true
      const formData = new FormData()
      formData.append('file', e.file)
      uploadPic(formData).then(res => {
        this.back_id = res.data.id
        this.back_img = process.env.viewURL + res.data.path
        this.isSubmit = false
      }).catch(() => {
        this.isSubmit = false
      })
    },
    handleSubmit() {
      if (!this.face_id) {
        this.$toast('请上传身份证头像图')
        return
      }
      if (!this.back_id) {
        this.$toast('请上传身份证国徽图')
        return
      }
      this.isSubmit = true
      let params = {
        face_id: this.face_id,
        back_id: this.back_id
      }
      getIdCardInfo(params).then(res => {
        res.data.face_id = this.face_id
        res.data.back_id = this.back_id
        setTimeout(() => {
          this.isSubmit = false
        }, 500)
        localStorage.setItem('cardInfo', JSON.stringify(res.data))
        if (!res.code) {
          this.$toast(res.msg)
          return
        }
        this.$router.push({
          path: '/withdrawal'
        })
      }).cath(() => {
        this.isSubmit = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
.upload-div {
  padding: 20px;
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 80px;
  box-sizing: border-box;
  .upload-title {
    font-size: 18px;
    font-weight: 500;
    color: #1E2020;
    line-height: 60px;
  }
  /deep/ .van-uploader__upload {
    border-radius: 4px;
    border: 1px solid ;
    overflow: hidden;
  }
  .upload-img {
    width: calc(100vw - 40px);
  }
  .submit-btn {
    width: 100%;
    left: 0;
    bottom: 0;
    height: 60px;
    background-color: #2F3131;
    position: fixed;
    padding: 6px 14px;
    box-sizing: border-box;
    .btn-txt {
      background-color: #F0E1C0;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 16px;
      color: #504632;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/uploadIDCard.vue